import VueRouter from "vue-router";
import store from "./store";
import Login from "./pages/Login";
import Dashboard from "./pages/account/Dashboard";
import WebApp from "./pages/account/WebApp";
import Project from "./pages/account/Project";
import Permissions from "./pages/account/Permissions";
import BookingHistory from "./pages/account/BookingHistory";
import UserList from "./pages/account/UserList";
import Report from "./pages/account/Report";
import ReportV3 from "./pages/account/ReportV3";
import ChapterImages from "./pages/account/ChapterImages";
import ReportSettings from "./pages/account/ReportSettings";
import TableTest from "./pages/TableTest";
import Contacts from "./pages/account/Contacts";
import Sites from "./pages/account/Sites";
import SiteDetail from "./pages/account/SiteDetail";
import DmDashboard from "./pages/account/dm/DmDashboard";
import DmAnlagen from "./pages/account/dm/DmAnlagen";
import DmAnlageDetail from "./pages/account/dm/DmAnlageDetail";
import DmParks from "./pages/account/dm/DmParks";
import DmAdressen from "./pages/account/dm/DmAdressen";
import DmDokumente from "./pages/account/dm/DmDokumente";
import DmMastr from "./pages/account/dm/DmMastr";
import DmPreislisten from "./pages/account/dm/DmPreislisten";
import DmPreislisteDetail from "./pages/account/dm/DmPreislisteDetail";
import DmKalkulator from "./pages/account/dm/DmKalkulator";
import DmPreislisteChat from "./pages/account/dm/DmPreislisteChat";
import DmAiUsage from "./pages/account/dm/DmAiUsage";
import DmAuditLog from "./pages/account/dm/DmAuditLog";

const routes = [
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/web-app",
    name: "web-app",
    component: WebApp,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/project-detail/:uid?",
    name: "project",
    component: Project,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/permissions",
    name: "permissions",
    component: Permissions,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/booking-history",
    name: "bookinghistory",
    component: BookingHistory,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/user-list",
    name: "userlist",
    component: UserList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/report/:projectUid?/:uid?",
    name: "report",
    component: Report,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/report-v3/:lang/:project_id/:inspect_id/:uid?",
    name: "reportV3",
    component: ReportV3,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/image-library",
    name: "imagelib",
    component: ChapterImages,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/report-settings",
    name: "reportsettings",
    component: ReportSettings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/logout",
    name: "logout",
    beforeEnter(to, from, next) {
      store.commit("logout");
      next("/login");
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      nocheck: true,
    },
  },
  {
    path: "/contacts",
    name: "contacts",
    component: Contacts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/sites",
    name: "sites",
    component: Sites,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/site/:uid",
    name: "site-detail",
    component: SiteDetail,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dm",
    name: "dm-dashboard",
    component: DmDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/dm/anlagen",
    name: "dm-anlagen",
    component: DmAnlagen,
    meta: { requiresAuth: true },
  },
  {
    path: "/dm/anlage/:id",
    name: "dm-anlage-detail",
    component: DmAnlageDetail,
    meta: { requiresAuth: true },
  },
  {
    path: "/dm/parks",
    name: "dm-parks",
    component: DmParks,
    meta: { requiresAuth: true },
  },
  {
    path: "/dm/adressen",
    name: "dm-adressen",
    component: DmAdressen,
    meta: { requiresAuth: true },
  },
  {
    path: "/dm/dokumente",
    name: "dm-dokumente",
    component: DmDokumente,
    meta: { requiresAuth: true },
  },
  {
    path: "/dm/mastr",
    name: "dm-mastr",
    component: DmMastr,
    meta: { requiresAuth: true },
  },
  {
    path: "/dm/preislisten",
    name: "dm-preislisten",
    component: DmPreislisten,
    meta: { requiresAuth: true },
  },
  {
    path: "/dm/preisliste/:id",
    name: "dm-preisliste-detail",
    component: DmPreislisteDetail,
    meta: { requiresAuth: true },
  },
  {
    path: "/dm/kalkulator",
    name: "dm-kalkulator",
    component: DmKalkulator,
    meta: { requiresAuth: true },
  },
  {
    path: "/dm/preisliste-chat",
    name: "dm-preisliste-chat",
    component: DmPreislisteChat,
    meta: { requiresAuth: true },
  },
  {
    path: "/dm/ai-usage",
    name: "dm-ai-usage",
    component: DmAiUsage,
    meta: { requiresAuth: true },
  },
  {
    path: "/dm/audit",
    name: "dm-audit",
    component: DmAuditLog,
    meta: { requiresAuth: true },
  },
  {
    path: "/table-test",
    name: "table-test",
    component: TableTest,
    meta: {
      nocheck: true,
    },
  },
  {
    path: "",
    component: Login,
  },
];

const router = new VueRouter({
  mode: "history",
  routes, // short for `routes: routes`
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.authStatus) {
      // DM-Zugriffsprüfung nur wenn Setup abgeschlossen
      if (to.path.startsWith("/dm") && store.state.account_setup_done && !store.getters.hasDmAccess) {
        next("/dashboard");
        return;
      }
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

export default router;
